<template>
  <v-container>
    <div class="display-2 mb-7 mt-5 font-weight-thin" color="primary">
      {{ $tc("entities.user.title", 2) }}
    </div>

    <alert-box v-model="alert.alerts" :type="alert.type"></alert-box>
    <btn-a rounded color="primary" @click="newUser" :access="$access.user.edit">
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <table-grid
      :headers="headers"
      :items="items"
      :loading="loadingTable"
      :loadingAction="loadingDialog"
      :actions="actions"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
      @input="pagination.page = $event"
      @search="searchTable"
    />

    <dialog-d
      ref="dialogRegTypesAccess"
      :title="itemSelected ? itemSelected.userName : ''"
      @confirm="saveRegTypes"
      :loading="regTypesAccess.loading"
      :accessConfirm="$access.user.edit"
      :accessDelete="$access.user.delete"
      :alert="regTypesAccess.alert"
    >
      <regTypesAccessForm v-model="itemSelected" />
    </dialog-d>

    <dialog-d
      ref="dialogResourcesAccess"
      :title="itemSelected ? itemSelected.userName : ''"
      @confirm="saveResources"
      :loading="resourcesAccess.loading"
      :accessConfirm="$access.user.edit"
      :accessDelete="$access.user.delete"
      :alert="resourcesAccess.alert"
    >
      <resourcesAccessForm v-model="itemSelected" />
    </dialog-d>

    <dialog-d
      ref="dialogAccess"
      :title="itemSelected ? itemSelected.userName : ''"
      @confirm="saveAccess"
      :loading="loadingAccess"
      :accessConfirm="$access.user.edit"
      :accessDelete="$access.user.delete"
      :alert="accessAlert"
    >
      <userAccessForm
        v-model="itemSelected"
        v-if="itemSelected"
        @change="changeAccess($event)"
      />
    </dialog-d>

    <dialog-d
      ref="dialogResetPassword"
      :title="itemSelected ? itemSelected.userName : ''"
      @confirm="saveResetPassword"
      :loading="loadingResetPassword"
      :accessConfirm="$access.user.edit"
      :alert="resetPasswordAlert"
    >
      <resetPasswordForm v-model="resetPasswordModel" v-if="itemSelected" />
    </dialog-d>

    <dialog-d
      ref="dialogNewUser"
      title="User"
      @confirm="saveNewUser"
      :loading="loadingNewUser"
      :accessConfirm="$access.user.edit"
      :alert="newUserAlert"
    >
      <newUserForm v-model="newUserModel" v-if="newUserModel" />
    </dialog-d>

    <dialog-d
      ref="dialogToken"
      :title="itemSelected ? itemSelected.userName : ''"
      @confirm="saveNewUser"
      :noActions="true"
      :accessConfirm="$access.user.edit"
    >
      <strong>Token:</strong>
      <div v-if="itemSelected">{{ itemSelected.token }}</div>
    </dialog-d>

    <dialog-d
      ref="dialogUpdateEnvironments"
      :title="itemSelected ? itemSelected.userName : ''"
      @confirm="sendUpdateEnvironments"
      :loading="updateEnvironments.loading"
      :accessConfirm="$access.user.edit"
      :alert="updateEnvironments.alert"
    >
      <v-select
        :label="$tc('entities.environment.title', 1)"
        v-if="itemSelected"
        v-model="itemSelected.environmentIds"
        :items="environments"
        item-text="description"
        item-value="id"
        multiple
      />
    </dialog-d>

    <dialog-d
      ref="dialogUpdateUserBasic"
      :title="itemSelected ? itemSelected.userName : ''"
      @confirm="saveUpdateUserBasic"
      :accessConfirm="$access.user.edit"
      :loading="updateUserBasic.loading"
      :alert="updateUserBasic.alert">
      <update-user-basic-form v-model="itemSelected"> </update-user-basic-form>
    </dialog-d>
  </v-container>
</template>

<script>
import environmentService from "@/services/environmentService";
import userService from "@/services/userService.js";
import userAccessForm from "../components/forms/users/userAccessForm";
import resetPasswordForm from "../components/forms/users/resetPasswordForm";
import newUserForm from "../components/forms/users/newUserForm";
import pageListMixing from "../mixins/pageLists/pageListMixing.js";
import regTypesAccessForm from "@/components/forms/users/regTypesAccessForm";
import resourcesAccessForm from "@/components/forms/users/resourcesAccessForm";
import resourceService from "@/services/resourceService";
import updateUserBasicForm from "@/components/forms/users/updateUserBasicForm";

export default {
  mixins: [pageListMixing],
  components: {
    userAccessForm,
    newUserForm,
    resetPasswordForm,
    regTypesAccessForm,
    resourcesAccessForm,
    updateUserBasicForm,
  },

  data() {
    return {
      apiController: "user",
      regTypesAccess: { loading: false, alert: { alerts: [], type: "error" } },
      resourcesAccess: {
        dialog: false,
        alert: { alerts: [], type: "error" },
        loading: false,
      },
      updateUserBasic: {
        dialog: false,
        alert: { alerts: [], type: "error" },
        loading: false,
      },
      entityService: userService,
      searchFields: ["Email", "UserName"],
      loadingAccess: false,
      access: {},
      loadingResetPassword: false,
      accessAlert: { alerts: [], type: "error" },
      newUserAlert: { alerts: [], type: "error" },
      resetPasswordAlert: { alerts: [], type: "error" },
      newUserModel: {},
      resetPasswordModel: {},
      loadingNewUser: false,
      environments: [],
      updateEnvironments: {
        loading: false,
        alert: { alerts: [], type: "error" },
      },
      headers: [
        {
          text: "Description",
          align: "left",
          sortable: false,
          value: "userName",
        },

        {
          text: this.$t("table.actions"),
          value: "action",
          sortable: false,
          align: "right",
        },
      ],
      actions: [
        {
          text: "Access",
          icon: "mdi-pencil",
          handle: this.editAccess,
          access: this.$access.user.edit,
        },
        {
          text: "Token",
          icon: "mdi-pencil",
          handle: (row) => {
            this.itemSelected = row;
            this.$refs.dialogToken.open();
          },
          access: this.$access.user.edit,
        },

        {
          text: this.$tc("entities.environment.title", 1),
          icon: "mdi-pencil",
          handle: this.openUpdateEnvironments,
          access: this.$access.user.edit,
        },
        {
          text: this.$tc("entities.regType.title", 1),
          icon: "mdi-pencil",
          handle: (row) => {
            this.itemSelected = row;
            this.$refs.dialogRegTypesAccess.open();
          },
          access: this.$access.user.edit,
        },
        {
          text: this.$tc("entities.resource.title", 2),
          icon: "mdi-pencil",
          handle: (row) => {
            this.itemSelected = row;
            this.$refs.dialogResourcesAccess.open();
          },
          access: this.$access.user.edit,
        },
        {
          text: "Update infos basic",
          icon: "mdi-pencil",
          handle: (row) => {
            this.itemSelected = row;
            this.$refs.dialogUpdateUserBasic.open();
          },
          access: this.$access.user.edit,
        },
        {
          text: "Reset Password",
          icon: "mdi-pencil",
          handle: this.resetPassword,
          access: this.$access.user.edit,
        },
        {
          text: this.$t("delete"),
          icon: "mdi-delete",
          handle: this.deleteItem,
          access: this.$access.user.delete,
        },
      ],
    };
  },
  methods: {
    async getResouces() {
      let res = await resourceService.getAll();
      if (res.success) this.resources = res.data.data;
      else this.resourcesAccess.alerts.alert = res.data;
    },
    openUpdateEnvironments(user) {
      this.itemSelected = user;
      this.$refs.dialogUpdateEnvironments.open();
    },
    async sendUpdateEnvironments() {
      this.updateEnvironments.loading = true;
      let res = await userService.updateEnvironments(
        this.itemSelected.id,
        this.itemSelected.environmentIds
      );
      this.updateEnvironments.loading = false;
      if (!res.success) {
        this.updateEnvironments.alert.alerts = res.data;
        return;
      }
      this.$refs.dialogUpdateEnvironments.open();
      await this.getItems();
    },
    async getEnvironments() {
      let res = await environmentService.getAll();
      if (res.success) this.environments = res.data.data;
      else this.updateEnvironments.alert.alerts = res.data;
    },
    async saveNewUser() {
      this.loadingNewUser = true;
      let res = await this.$http.post("user/register", this.newUserModel);

      if (res.success) {
        this.$refs.dialogNewUser.open();
        this.newUserModel = null;
        await this.getItems();
        return;
      }

      this.newUserAlert.alerts = res.data;
      this.loadingNewUser = false;
    },
    async saveUpdateUserBasic(){
      let user = this.itemSelected;
         this.updateUserBasic.loading = true;
      let res = await userService.updateUserBasic(user.id,user.userName,user.code);
      this.updateUserBasic.loading = false;
      if(!res.success) { 
        this.updateUserBasic.alert.alerts = res.data;
        return;
      }else{
        this.$refs.dialogUpdateUserBasic.open();
      }
    },
    newUser() {
      this.newUserModel = this.getNewUserModel();
      this.$refs.dialogNewUser.open();
    },
    resetPassword(user) {
      this.itemSelected = user;
      this.resetPasswordModel = this.getResetPasswordModel();
      this.$refs.dialogResetPassword.open();
    },
    editAccess(user) {
      this.itemSelected = user;
      this.$refs.dialogAccess.open();
    },
    async saveResetPassword() {
      this.loadingResetPassword = true;
      let res = await this.$http.put(
        `user/reset-password?userId=${this.itemSelected.id}`,
        this.resetPasswordModel
      );

      if (res.success) {
        this.$refs.dialogResetPassword.open();
        this.itemSelected = null;
        await this.getItems();
        return;
      }

      this.resetPasswordAlert.alerts = res.data;
      this.loadingResetPassword = false;
    },
    async saveAccess() {
      this.loadingAccess = true;
      let res = await this.$http.put(
        `user/access-manager?userId=${this.access.userId}`,
        this.access.accessManager
      );

      if (res.success) {
        this.$refs.dialogAccess.open();
        this.itemSelected = null;
        await this.getItems();
        return;
      }

      this.accessAlert.alerts = res.data;
      this.loadingAccess = false;
    },
    changeAccess(access) {
      this.access = access;
    },
    getResetPasswordModel() {
      return { password: "", confirmPassword: "" };
    },
    getNewUserModel() {
      return {
        userName: "",
        password: "",
        confirmPassword: "",
        environmentIds: [],
      };
    },
    getModelDefault() {
      return {
        code: "",
        description: "",
      };
    },
    openRegTypesAccess() {},
    async saveResources() {
      this.resourcesAccess.loading = true;
      let res = await userService.updateResources(
        this.itemSelected.id,
        this.itemSelected.resourceIds
      );
      this.resourcesAccess.loading = false;
      if (res.success) {
        this.$refs.dialogResourcesAccess.open(false);
      } else {
        this.resourcesAccess.alert.alerts = res.data;
      }
    },
    async saveRegTypes() {
      this.regTypesAccess.loading = true;
      let res = await userService.updateRegTypes(
        this.itemSelected.id,
        this.itemSelected.regTypeIds
      );
      this.regTypesAccess.loading = false;
      if (res.success) {
        this.$refs.dialogRegTypesAccess.open(false);
      } else {
        this.regTypesAccess.alert.alerts = res.data;
      }
    },
  },
  async mounted() {
    await this.getItems();
    await this.getEnvironments();
  },
};
</script>
